export default "__VITE_ASSET__DG17FMAa__"